export default __webpack_public_path__ + "static/media/BrainBreak cards5.5558fcd9.png";